import { CircularProgress } from "@mui/material";
import { useState } from "react";
import { Modal } from "src/components/Modals/Components/ModalsComponents";
import QuestionView from "src/components/NewComponents/Search/QuestionsView/QuestionView";
import { useQuestion } from "src/hooks/useQuestions";
import { QuestionsListSettingsProvider } from "src/reducers/questions";
import { ModalMaxWidth } from "src/types/enums";

interface QuestionViewModalProps {
	questionId: string | number;
	onClose: () => void;
	settings?: Record<string, unknown>;
}

export const QuestionViewModal = ({ questionId, onClose, settings = {} }: QuestionViewModalProps) => {
	const [answer, setAnswer] = useState(null);
	const { data: question, isLoading } = useQuestion(questionId);

	return (
		<Modal
			open
			onClose={onClose}
			className="last_commented_question--container"
			maxWidth={ModalMaxWidth.md}
		>
			{!isLoading && (
				<div className="last_commented_question p-relative">
					<QuestionsListSettingsProvider settings={settings}>
						<QuestionView
							className="last_commented_question--view"
							searchValue=""
							question={{
								...question,
								...answer,
							}}
							disabledSettings={undefined}
							setAnswer={(a: unknown) => setAnswer(a)}
						/>
					</QuestionsListSettingsProvider>
				</div>
			)}
			{isLoading && (
				<div className="flex-center-row">
					<CircularProgress />
				</div>
			)}
		</Modal>
	);
};
